/**
 * Normalize US phone numbers to (510) 555-1212.
 *
 * 10 digits            -> (NNN) NNN-NNNN
 * 11 digits leading 1  -> (NNN) NNN-NNNN
 * anything else        -> the original input, untouched (never drop user data)
 */
export function normalizePhone(input: string | null | undefined): string {
  const raw = (input ?? "").trim();
  if (raw === "") return "";

  const digits = raw.replace(/\D/g, "");
  let ten: string | null = null;
  if (digits.length === 10) ten = digits;
  else if (digits.length === 11 && digits.startsWith("1")) ten = digits.slice(1);

  if (!ten) return raw;
  return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
}

/** E.164 (+1NNNNNNNNNN) for US numbers, or null when it can't be parsed. */
export function toE164(input: string | null | undefined): string | null {
  const digits = (input ?? "").replace(/\D/g, "");
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  return null;
}

/**
 * Google account the crew terminal uses for Google Voice. Passed as the
 * `authuser` param so links open under the SquadFlight account regardless of
 * which Google account is signed in first (/u/0/) in the browser.
 */
const GV_ACCOUNT = "m@squadflight.com";

/** Opens Google Voice's "call now" screen so the arena number is the caller ID. */
export function googleVoiceCallUrl(phone: string): string {
  return `https://voice.google.com/calls?a=nc,${encodeURIComponent(normalizePhone(phone))}&authuser=${encodeURIComponent(GV_ACCOUNT)}`;
}

/** Opens the Google Voice message thread for this number. */
export function googleVoiceTextUrl(phone: string): string {
  const e164 = toE164(phone) ?? normalizePhone(phone);
  return `https://voice.google.com/messages?itemId=t.${encodeURIComponent(e164)}&authuser=${encodeURIComponent(GV_ACCOUNT)}`;
}
